import Backbone from 'backbone'
import _ from 'lodash'
import ChartDesignerSortSettings from 'scoreboard/charts/model/chart-designer-sort-settings'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import template from './sort-settings-view.hbs'
import directionText from './direction-text'
import EditSortSettingsView from './edit-sort-settings-view'
import * as sortLabels from './sort-labels'

const SortSettingsView = Backbone.View.extend({

	/**
	 * @type ChartDesignerSortSettings
	 */
	model: null,

	/**
	 * @type ChartDesigner
	 */
	chart: null,

	events: {
		'click .edit-sort-settings': 'onClickEdit'
	},

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {ChartDesignerSortSettings} options.model
	 *
	 * @param {ChartDesigner} options.chart
	 */
	initialize: function(options = {}) {
		this.options = options
		this.chart = this.options.chart
	},

	render() {
		this.$el.empty().append(template(this.context()))

		this.$el.toggleClass('is-not-displayed', !this.display({}))

		return this
	},

	context: function () {
		return {
			label: this.label || i18n.get('charts.sort.sorting'),
			sortByText: sortLabels.sortByText({
				sortSettings: this.model,
				sortObjectType: this.sortObjectType
			}),
			directionText: directionText(this.model.pick('sortType', 'direction'))
		}
	},

	/**
	 * Returns whether the panel should be displayed when active
	 */
	display: function () {
		return true
	},

	onClickEdit: function () {
		let clonedSettings = new ChartDesignerSortSettings(
			_.cloneDeep(this.model.attributes))

		let editView = new EditSortSettingsView({
			model: clonedSettings,
			chart: this.chart,
			sortObjectType: this.sortObjectType
		})

		appDisplay.dialog(editView)

		this.listenToOnce(editView, 'done', () => {
			this.model.set(clonedSettings.toJSON())
			this.trigger('change')
		})
	}
})

export default SortSettingsView

SortSettingsView.__filename__ = 'charts/edit/sort/sort-settings-view.js'
